"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeProcess = void 0;
const _base_1 = require("./_base");
const fake_worker_1 = require("../../child-process/fake-worker");
class FakeProcess extends _base_1.WorkerPlatformBase {
    constructor() {
        super();
        this._isFakeProcess = true;
        this.worker = new fake_worker_1.FakeWorker((m) => {
            this.emit('message', m);
        });
    }
    kill() {
        // @todo: needs some implementation.
        this.emit('close');
    }
    send(m) {
        this.worker.onMessageFromParent(m);
    }
}
exports.FakeProcess = FakeProcess;
//# sourceMappingURL=fakeWorker.js.map